import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { GithubOutlined, LinkedinFilled, MailOutlined } from '@ant-design/icons';
import logo from '../assets/img/logo.png';
import { CvIcon } from './icons/CvIcon';

const NAV_LINKS = ['home', 'about', 'education', 'work', 'projects'];

const SOCIAL_LINKS = [
    { href: 'https://www.linkedin.com/in/guybarel', label: 'LinkedIn profile', Icon: LinkedinFilled },
    { href: 'https://github.com/guy915', label: 'GitHub profile', Icon: GithubOutlined },
    { href: 'mailto:guybarel2006@gmail.com', label: 'Email Guy', Icon: MailOutlined },
    { href: `${process.env.PUBLIC_URL}/resume.pdf`, label: 'Resume PDF', Icon: CvIcon },
];

export const NavBar = () => {
    const [activeLink, setActiveLink] = useState('home');
    const [scrolled, setScrolled] = useState(false);
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setScrolled(window.scrollY > 50);

            const scrollPosition = window.scrollY + window.innerHeight / 2;
            document.querySelectorAll('section').forEach((section) => {
                const top = section.offsetTop;
                if (scrollPosition >= top && scrollPosition < top + section.offsetHeight) {
                    setActiveLink(section.getAttribute('id'));
                }
            });
        };

        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <Navbar
            expand="lg"
            expanded={expanded}
            onToggle={setExpanded}
            className={scrolled || expanded ? 'scrolled' : ''}
        >
            <Container>
                <Navbar.Brand href="#home">
                    <img src={logo} alt="" height={50} />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav">
                    <span className="navbar-toggler-icon"></span>
                </Navbar.Toggle>
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        {NAV_LINKS.map((id) => (
                            <Nav.Link
                                key={id}
                                href={`#${id}`}
                                className={activeLink === id ? 'active-navbar-link' : 'navbar-link'}
                                onClick={() => {
                                    setActiveLink(id);
                                    setExpanded(false);
                                }}
                            >
                                {id}
                            </Nav.Link>
                        ))}
                    </Nav>
                    <span className="navbar-text">
                        <div className="social-icon">
                            {SOCIAL_LINKS.map(({ href, label, Icon }) => (
                                <a
                                    key={label}
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title=""
                                    aria-label={label}
                                >
                                    <Icon style={{ color: '#D8D8D8' }} />
                                </a>
                            ))}
                        </div>
                    </span>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};
